import React from "react";
import { Box } from "@components/Box/Box";
import { aspectRatioToPadding } from "@utils/aspectRatioToPadding";
import styles from "./styles.module.scss";
import { PrimitiveProps } from "@helpers/interfaces/primitive";
import classnames from "classnames";
import { breakpoints } from "@helpers/breakpoints";
export interface AspectRatioProps extends PrimitiveProps {
  ratio: string | string[];
}
const buildStyle = (ratios: string | string[], classname: string): string => {
  const breakpoint = [0, ...breakpoints];
  if (Array.isArray(ratios)) {
    return ratios
      .map(ratio => {
        const nextBreakpoint = breakpoint.shift();
        return nextBreakpoint === 0
          ? `.${classname}{padding-bottom:${ratio};}`
          : `@media only screen and (min-width: ${nextBreakpoint}){.${classname}{padding-bottom:${ratio};}}`;
      })
      .join("");
  }
  return `.${classname}{padding-bottom:${ratios};}`;
};
const AspectRatio: React.FC<AspectRatioProps> = ({
  ratio,
  className,
  children,
  ...props
}) => {
  const isArray = Array.isArray(ratio);
  return (
    <>
      {isArray && (
        <style>
          {buildStyle(aspectRatioToPadding(ratio), styles.aspectratioRatio + "-" + className)}
        </style>
      )}
      <Box className={classnames(styles.aspectratio, className)} {...props}>
        <Box
          className={styles.aspectratioRatio + "-" + className}
          {...(!isArray && {
            style: { paddingBottom: aspectRatioToPadding(ratio) as string }
          })}
        />
        {children && <Box className={styles.aspectratioInner}>{children}</Box>}
      </Box>
    </>
  );
};
AspectRatio.defaultProps = {
  ratio: ["4:3"]
};
export { AspectRatio };